import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Title: {
    id: 'research_focus_title',
    defaultMessage: 'Research focus areas',
  },
  ResearchFocus: {
    id: 'label_research_focus',
    defaultMessage: 'Research focus',
  },
  ResearchFocusHelp: {
    id: 'help_research_focus',
    defaultMessage: 'Uses research focus set on content if not set here.',
  },
  Close: {
    id: 'Close',
    defaultMessage: 'Close',
  },
});
